const account_settings = {
  permissionSource: 'api::account-setting.account-setting',
  detailTitle: 'Account Setting',
  detailEndPoint: '/account-setting',
  detail: [
    {
      label: 'Lock voucher on or before',
      value: 'lock_voucher_on_or_before',
      tag: 'date-picker',
    },
  ],
}
export default account_settings
